
import Vue from "vue";

export default Vue.extend({
  name: "deny-gps-alert-view",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    btnAction: { type: String, default: "OK" },
  },
  computed: {
    showTitle(): string {
      return this.title === ""
        ? (this.$i18n.t("Alert.denyGpsTitle") as string)
        : this.title;
    },
    showSubtitle(): string {
      return this.subtitle === ""
        ? (this.$i18n.t("Alert.denyGpsSubTitle") as string)
        : this.subtitle;
    },
  },
  methods: {
    goToView() {
      this.$emit("okClicked");
      window.open("https://static.vacan.com/current_location/index.html");
    },
    okClicked() {
      this.$emit("okClicked");
    },
  },
});
